import { render, staticRenderFns } from "./PortfolioSection.htm?vue&type=template&id=12625add&scoped=true&"
import script from "./PortfolioSection.ts?vue&type=script&lang=js&"
export * from "./PortfolioSection.ts?vue&type=script&lang=js&"
import style0 from "./PortfolioSection.scss?vue&type=style&index=0&id=12625add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12625add",
  null
  
)

export default component.exports